import { render, staticRenderFns } from "./ProductReviews.vue?vue&type=template&id=a7163ad6&"
import script from "./ProductReviews.vue?vue&type=script&lang=ts&"
export * from "./ProductReviews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports